<template>
  <div class="container">
    <div class="main1">
      <!-- <div class="leftbannner"></div> -->
      <div class="rightlogin">
        <div class="top">
          <a href="/">
            <div class="logo">
              <img class="img1" src="../../assets/images/index_logo.png" alt="">
              <!-- <img class="img2" style="width:200px;height:43px" src="../../assets/images/yixinglogo3.png"> -->
              <!-- <img class="img2" src="../../assets/images/index_logo3.png" alt=""> -->
            </div>
          </a>
        </div>
        <div class="text gray-9 flex">
          —— 网络货物运输经营者专属平台 ——
        </div>
        <div style="color:#fff;padding:20px;display:none">
          <h2 style='font-size:28px'>尊敬的客户您好：</h2>
          <div style='font-size:26px;line-height:2.5;text-indent:50px'>为了给您提供更优质、完善的服务，我公司拟于 6 月 2 日 12:00~6 月 2 日 24:00 对系统进
            行升级维护，期间您可能无法正常使用中成智运网络货运平台、手机小程序进行建单、结算等业务，
            由此给您带来的不便，敬请谅解！</div>
        </div>
        <div class="bottom">
          <p class="title">
            <span class="max">{{request.type=='PASSWORD'?'密码':'验证码'}}登录</span>
            <span class="min" @click="changeForm">{{request.type=='PASSWORD'?'验证码':'密码'}}登录</span>
          </p>
          <el-form ref="pwd" v-if="request.type=='PASSWORD'" :model="request" class="form" @submit.native.prevent>
            <el-form-item :rules="filter_rules(true,'phone')" prop="name">
              <el-input class="aa" :autocomplete="off" maxlength="11" v-model.trim="request.name" placeholder="请输入手机号" clearable>
                <i slot="prefix" class="xy xy-icon25"></i>
              </el-input>
            </el-form-item>
            <el-form-item :rules="filter_rules(true,'pwd')" prop="key">
              <el-input class="aa" maxlength="18" v-model.trim="request.key" type="password" placeholder="请输入密码" clearable>
                <i slot="prefix" class="xy xy-icon24"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="rember">
              <el-checkbox v-model="checked">自动登录</el-checkbox>
              <span style="color:#409eff;float: right;cursor:pointer" @click="showInsuranceFun">《平台抽成比例公示》</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" native-type="submit" class="loginBtn" @click="loginPwd('pwd')">登 录</el-button>
            </el-form-item>
          </el-form>
          <el-form ref="sms" v-else :model="request" class="form" @submit.native.prevent>
            <el-form-item :rules="filter_rules(true,'phone')" prop="name">
              <el-input class="aa" maxlength="11" :autocomplete="off" v-model.trim="request.name" placeholder="请输入手机号" clearable>
                <i slot="prefix" class="xy xy-icon25"></i>
              </el-input>
            </el-form-item>
            <el-form-item :rules="filter_rules(true,'number')" prop="key">
              <el-input placeholder="请输入验证码" :autocomplete="off" class="aa" maxlength="4" v-model="request.key" style="width:225px" clearable><i slot="prefix" class="xy xy-icon29" style="font-size:15px"></i></el-input>
              <el-button type="primary" style="height:48px;width:130px" v-show="!showBtn" @click="getCode">获取验证码</el-button>
              <el-button type="primary" v-show="showBtn" style="height:48px;width:120px" disabled>{{count}}秒后重新获取</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" native-type="submit" class="loginBtn" @click="loginSms('sms')">登 录</el-button>
            </el-form-item>
          </el-form>
          <p class="register" @click="utils.toUrl('/auth/register')">注册</p>
        </div>
      </div>
    </div>
    <el-dialog title="关于平台抽成比例公示" :visible.sync="showInsurance" width="1000px" center>
      <service />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showInsurance = false" v-show="show1">确 定</el-button>
        <el-button type="primary" disabled="disabled" v-show="!show1">确定（{{count1}}s）</el-button>
        <!-- <el-button @click="showInsurance =false">取 消</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Service from "./service.vue";
import { refreshLoginInfo } from '@/assets/js/utils'
export default {
  components: {
    Service
  },
  data () {

    return {
      showInsurance: false,
      timer1: null,
      count1: null,
      show1: true,
      off: 'off',
      showBtn: false,
      count: "60",
      checked: false,
      flag: false,
      request: {
        key: "",
        name: "",
        type: "PASSWORD",
        login_method: 'PC'
      }
    };
  },
  methods: {
    showInsuranceFun () {
      this.showInsurance = true
      this.getCode1()
    },
    getCode1 () {
      let _this = this;
      _this.show1 = false;
      const TIME_COUNT = 10;
      if (!_this.timer1) {
        _this.count1 = TIME_COUNT;
        _this.show1 = false;
        _this.timer1 = setInterval(() => {
          if (_this.count1 > 0 && _this.count1 <= TIME_COUNT) {
            _this.count1--;
          } else {
            _this.show1 = true;
            clearInterval(_this.timer1);
            _this.timer1 = null;
          }
        }, 1000)
      }
    },
    getCode () {
      let reg = /^1(2|3|4|5|6|7|8|9)\d{9}$/;
      if (!this.request.name) {
        alert("请输入手机号");
      } else if (reg.test(this.request.name)) {
        if (this.count <= 0 || this.count == 60) {
          this.api(150103, {
            phone: this.request.name,
            msg_type: "LOGIN"
          }).then(res => {
            if (this.utils.isSuccess(res)) {
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.showBtn = true;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.showBtn = false;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000);
              }
            } else {
              alert(res.biz_msg)
            }
          });
        }
      } else {
        alert("手机号有误");
      }
    },
    changeForm () {
      if (this.request.type == "PASSWORD") {
        this.request.type = "SMS";
        this.request.name = '';
        this.request.key = '';
        this.$refs['pwd'].clearValidate();
      } else {
        this.request.type = "PASSWORD";
        this.request.name = '';
        this.request.key = '';
        this.$refs['sms'].clearValidate();
      }
    },
    loginPwd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (!this.flag) {
          //   let Base64 = require("js-base64").Base64;
          //   this.request.key = Base64.encode(this.request.key);
          //   this.flag = true
          // }
          this.api(150101, this.request).then(res => {
            let data;
            if ((data = this.utils.isSuccess(res))) {
              let arr = [];
              _global_.TOKEN = data.token;
              _global_.USER_TYPE = data.type.name;
              _global_.AUTH = data.audit_status.name;
              arr.push(data)
              _global_.TOKEN_LIST = arr
              refreshLoginInfo(this)
              this.utils.toUrl("/waybill/waybill-list");
            } else {
              alert(res.biz_msg)
            }
          });
        }
      });
    },
    loginSms (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.api(150101, this.request).then(res => {
            let data;
            if ((data = this.utils.isSuccess(res))) {
              let arr = [];
              _global_.TOKEN = data.token;
              _global_.USER_TYPE = data.type.name;
              _global_.AUTH = data.audit_status.name;
              arr.push(data)
              _global_.TOKEN_LIST = arr
              refreshLoginInfo(this)
              this.utils.toUrl("/waybill/waybill-list");
            } else {
              alert(res.biz_msg)
            }
          });
        }
      });
    }
  }
};


</script>

<style scoped lang="scss">
$bgimg: "https://website-mp4.obs.cn-north-4.myhuaweicloud.com:443/1642124173559.png";
.container {
  width: 100%;
  height: 100%;
  // background: #f5f5f5;
  background: url($bgimg) no-repeat;
  background-size: 100%;
  overflow: hidden;
  position: relative;
  .main1 {
    width: 559px;
    height: 604px;
    position: absolute;
    right: 10%;
    top: 25%;
    // height: 604px;
    // margin: 80px auto 0;
    // overflow: hidden;
    // background: #fff;
    display: flex;
    align-items: center;
    .leftbannner {
      display: inline-block;
      width: 636px;
      height: 604px;
    }
    .rightlogin {
      display: inline-block;
      width: 559px;
      height: 604px;
      background-color: rgba(151, 147, 144, 0.5);
      .text {
        justify-content: center;
        font-size: 16px;
        color: #fff;
      }
      .top {
        padding-top: 60px;
        .logo {
          width: 100%;
          // height: 84px;
          display: flex;
          justify-content: center;
          // background: url(../../assets/images/index_logo.png) no-repeat;
          // margin: 0 auto;
          .img1 {
            position: relative;
            left: -11px;
          }
          .img2 {
            height: 35px;
            position: relative;
            top: 12px;
            left: 11px;
          }
        }
      }
      .bottom {
        padding: 60px 100px;
        .title {
          margin: 0;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 361px;
          .max {
            font-size: 20px;
            color: #fff;
          }
          .min {
            font-size: 14px;
            color: #409eff;
            cursor: pointer;
          }
          .min:hover {
            color: #409eff;
          }
        }
        .form {
          width: 361px;
          .loginBtn {
            width: 100%;
            height: 48px;
            font-size: 20px;
          }
        }
        .register {
          color: #fff;
          cursor: pointer;
          text-align: center;
        }
        .register:hover {
          color: #409eff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/login.vue